module.exports = __webpack_public_path__ + "static/media/marker.67a40b57.png";